import React, { Component } from 'react';
import { ConnectedRouter } from 'react-router-redux'
import { Route } from 'react-router-dom';
import history from '../../utils/history';
import ScrollToTop from '../../components/navigation/SrollToTop';
import SignUp from '../signup/SignUp';
import Dashboard from '../dashboard/DashboardScreen';
import Files from '../files/Files';
import FileDetails from '../fileDetails/FileDetails';
import Projects from '../projects/Projects';
import Plans from '../plans/Plans';
import Checklist from '../checklist/Checklist';
import Category from '../category/Category';
import Location from '../category/Location';
import ProjectDetails from '../projectDetails/ProjectDetails';
import Templates from '../templates/Templates';
import Settings from '../settings/Settings';
import Payment from '../payment/Payment';
import IssuesView from '../issues/Issues';
import { router as config } from '../../config';

export default class Router extends Component {
  render() {
    return (
      <ConnectedRouter basename={config.basename} history={history}>
        <div>
          <Route path="/" exact component={SignUp} />
          {/*<Route path="/pricing" exact component={Payment} />*/}
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/dashboard/files" name="files" component={Files} />
          <Route path="/dashboard/projects" name="projects" component={Projects} />
          <Route path="/dashboard/plans" name="plans" component={Plans} />
          <Route path="/dashboard/issues" name="issues" component={IssuesView} />
          <Route path="/dashboard/checklist" name="checklist" component={Checklist} />
          <Route path="/dashboard/templates" name="templates" component={Templates} />
          <Route path="/dashboard/settings" name="settings" component={Settings} />
          <Route path="/dashboard/project/:projectId" name="project" component={ProjectDetails} />
          <Route path="/dashboard/category/:projectId/:categoryId" name="category" component={Category} />
          <Route path="/dashboard/location/:projectId/:locationId" name="location" component={Location} />
          <Route path="/details/:projectId/:fileId" name="file-details" component={FileDetails} />
        </div>
      </ConnectedRouter>
    );
  }
}
